import { useLocation } from 'react-router-dom';

export const useLastRoutePath = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  return pathSegments.length > 0 ? `/${pathSegments[pathSegments.length - 1]}` : '/';
};
